import './site-footer.scss';
require('../../assets/images/staatlich_garantiert.svg');

class Footer {
    constructor (element) {
        this.$footer = element;
        this.$$navAccordions = this.$footer.querySelectorAll('[data-nav="accordion"]');
    }

    initialize () {
        this.checkSize();

        window.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        if (window.innerWidth < window.OPTIONS.breakpoints.xl) {
            this.handleAccordionHtmlTags();
        } else {
            this.handleAccordionHtmlTags(true);
        }
    }

    handleAccordionHtmlTags (deactivateAccordions = false) {
        if (deactivateAccordions === true) {
            this.$$navAccordions.forEach($navAccordion => {
                if (!$navAccordion.hasAttribute('data-accordion-desktop')) {
                    if ($navAccordion.classList.contains('is--active')) {
                        $navAccordion.classList.remove('is--active');
                    }

                    $navAccordion.setAttribute('aria-pressed', 'false');
                    $navAccordion.setAttribute('aria-hidden', 'true');
                    $navAccordion.setAttribute('tabindex', '-1');
                }
            });
        } else {
            this.$$navAccordions.forEach($navAccordion => {
                if ($navAccordion.hasAttribute('aria-hidden')) {
                    $navAccordion.removeAttribute('aria-hidden');
                }

                if ($navAccordion.hasAttribute('tabindex')) {
                    $navAccordion.removeAttribute('tabindex');
                }
            });
        }
    }
}

export { Footer };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $footer = $context.querySelector('[data-footer="root"]');

    if ($footer) {
        const footer = new Footer($footer);
        footer.initialize();
    }
});
